import PropTypes from 'prop-types';
import { colorPropTypes } from '../utils/color_prop';
import deprecatedProp from '../utils/deprecated_prop';
var propTypes = {
  ['aria-label']: PropTypes.string,
  ['aria-labelledby']: PropTypes.string,
  ['aria-describedby']: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.oneOfType([PropTypes.oneOf(colorPropTypes), PropTypes.string]),
  customStyle: PropTypes.any,
  disabled: PropTypes.bool,
  display: PropTypes.oneOf(['block', 'inline-block', 'none']),
  filled: PropTypes.bool,
  /** @deprecated */
  focusable: deprecatedProp(PropTypes.bool, "To make an Icon focusable, wrap it in a interactive element that better suits the context"),
  /** @deprecated */
  label: deprecatedProp(PropTypes.string, "Use aria-label or aria-labelledby instead."),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default propTypes;